module.exports = __webpack_public_path__ + "img/sparkling-heart.796dece6.png";